export const duplicatesCardInfo = {
	title: "Duplicados",
	subtitle: "Duplicado",
	dueDate: "Vencimiento",
	value: "Valor",
};
